import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next'; // 1. Import hook

const OurMission = () => {
  const { t } = useTranslation(); // 2. Initialize translation function

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 8, md: 12 },
        textAlign: 'center',
      }}
    >
      <Container maxWidth="md">
        {/* The Section Heading */}
         <Typography
            variant="h3"
            component="h2"
            sx={{
              fontWeight: 500,
              mb: 3,
              lineHeight: 1.3,
              fontFamily: 'serif',
              color:'#005F69',
              textAlign: 'center'
            }}
          >
          {t('mission_headline')} {/* 3. Use translation */}
        </Typography>

        {/* The Mission Paragraph */}
        <Typography
          variant="h6"
          component="p"
          sx={{
            fontFamily: '"Lato", "Helvetica", "Arial", sans-serif',
            fontWeight: 400,
            color: 'text.secondary',
            lineHeight: 1.8,
            maxWidth: '750px',
            mx: 'auto',
          }}
        >
          "{t('mission_paragraph')}" {/* 3. Use translation */}
        </Typography>
      </Container>
    </Box>
  );
};

export default OurMission;